import { PREFIXED_ROUTES } from 'src/common/constants';

/**
 * Converts a relative dashboard path into a relative dashboard path with the Zillow domain prefix.
 * Doesn't duplicate the zillow prefix if the path already contains it.
 */
export const getZillowPath = (localPath: string): string => {
    if (localPath.startsWith(PREFIXED_ROUTES.ZHL_BASE_ON_ZILLOW)) {
        return localPath;
    }
    return `${PREFIXED_ROUTES.ZHL_BASE_ON_ZILLOW}${localPath}`;
};
